import axios from 'axios'
const state = {
    loading: false,
    orders: [],
    products: [],
    order: null,
    page: 1,
    size: 12,
    hasMore: true,
    tableOptions: {
        tableHeaders: [],
        tableData: [],
        accessTableData: [],
        loading: false,
        tableMeta: {
            total: 10,
            page: 1,
        },
    }
};
const getters = {
    getLoadingStatus(state) {
        return state.loading;
    },
    getOrder(state) {
        return state.order
    },
    getOrders(state) {
        return state.orders
    },
    getProducts(state) {
        return state.products
    },
    getTableOptions(state) {
        return state.tableOptions
    },
    getHasMore(state) {
        return state.hasMore;
    },
};

const mutations = {
    setLoadingStatus(state, status) {
        state.loading = status;
    },
    setOrder(state, order) {
        state.order = order;
    },
    setOrders(state, orders) {
        state.orders = orders
    },
    appendOrders(state, orders) {
        state.orders = [...state.orders, ...orders];
    },
    setProducts(state, products) {
        state.products = products
    },
    appendProducts(state, products) {
        state.products = [...state.products, ...products];
    },
    setPage(state, page) {
        state.page = page;
    },
    setHasMore(state, status) {
        state.hasMore = status;
    },
    resetOrders(state) {
        state.orders = [];
        state.page = 1;
        state.hasMore = true;
    },
    setLoading(state, status) {
        state.tableOptions.loading = status
    },
    setTableData(state, tableInfo) {
        state.tableOptions.tableHeaders = tableInfo.tableHeaders
        state.tableOptions.tableData = tableInfo.tableData
        state.tableOptions.accessTableData = tableInfo.accessTableData
        state.tableOptions.tableMeta.total = tableInfo.tableMeta.total
        state.tableOptions.tableMeta.page = tableInfo.tableMeta.page
    },
};

const actions = {

    async fetchB2cOrders({ commit, state }, queryParams = {}) {
        if (state.loading || !state.hasMore) return;
        try {
            commit('setLoadingStatus', true);
            const response = await axios.get("/b2c/order", {
                params: {
                    page: state.page,
                    size: state.size,
                    ...queryParams
                }
            });
            const { data, meta } = response.data;
            console.log("Fetching page:", state.page);
            if (state.page === 1) {
                commit('setOrders', data);
            } else {
                commit('appendOrders', data);
            }
            if (meta.current_page < meta.last_page) {
                commit('setPage', state.page + 1);
            } else {
                commit('setHasMore', false);
            }
        } catch (err) {
            console.log(err);
        } finally {
            commit('setLoadingStatus', false);
        }
    },

    async fetchMaterialInvintory({ commit, state }, queryParams = {}) {
        if (state.loading || !state.hasMore) return;
        try {
            commit('setLoadingStatus', true);
            const response = await axios.get("/catalog/product/inventory", {
                params: {
                    page: state.page,
                    size: state.size,
                    ...queryParams
                }
            });
            const { data, meta } = response.data;
            console.log("Fetching page:", state.page);
            const dataSet = data.map((el) => { return { ...el, quantity: 0 } });
            if (state.page === 1) {
                commit('setProducts', dataSet);
            } else {
                commit('appendProducts', dataSet);
            }
            if (meta.current_page < meta.last_page) {
                commit('setPage', state.page + 1);
            } else {
                commit('setHasMore', false);
            }
        } catch (err) {
            console.log(err);
        } finally {
            commit('setLoadingStatus', false);
        }
    },

    async fetchB2cOrdersMe({ commit, state }, queryParams = {}) {
        if (state.loading || !state.hasMore) return;
        try {
            commit('setLoadingStatus', true);
            const response = await axios.get("/b2c/order/me", {
                params: {
                    page: state.page,
                    size: state.size,
                    ...queryParams
                }
            });
            const { data, meta } = response.data;
            console.log("Fetching page:", state.page);
            if (state.page === 1) {
                commit('setOrders', data);
            } else {
                commit('appendOrders', data);
            }
            if (meta.current_page < meta.last_page) {
                commit('setPage', state.page + 1);
            } else {
                commit('setHasMore', false);
            }
        } catch (err) {
            console.log(err);
        } finally {
            commit('setLoadingStatus', false);
        }
    },


    async fetchOrders({ commit }, queryParams) {
        try {
            commit('setLoading', true)
            let params = {};
            for (let key in queryParams) {
                if (queryParams[key]) {
                    params[key] = queryParams[key];
                }
            }
            if (!queryParams.paginated) params.paginated = queryParams.paginated;
            const response = await axios.get("/b2c/order", {
                params,
            });
            commit('setOrders', response.data.data)
            // commit('setTableData', {
            //     tableHeaders: [
            //         "name",
            //         "Code",
            //         "Exchange",
            //         "settings",
            //     ],
            //     tableData: response.data.data,
            //     accessTableData: [
            //         ["name"],
            //         ["code"],
            //         ["exchange"],
            //     ],
            //     tableMeta: {
            //         total: response.data.meta.total,
            //         page: response.data.meta.current_page,
            //     },
            // })
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoading', false)
        }
    },
    async fetchOrder({ commit }, id) {
        try {
            commit('setLoadingStatus', true)
            const response = await axios.get(`/b2c/order/${id}`);
            commit('setOrder', response.data.data);
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoadingStatus', false)
        }
    },

}


export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}